"use client";

import type { FC } from "react";

import type { CartConfiguration } from "@jti/cart";
import { CartApp } from "@jti/cart/CartApp";
import { Container } from "@jti/core-components/components/Container";

import { mapAgeVerificationMethodImages, mapLoyalty } from "@/libs/builder/common/reactAppsAuthoringMapping";

import type { cartInputs } from "./Cart.builder";

export type CartProps = BuilderComponentProps<typeof cartInputs>;

export const Cart: FC<CartProps> = ({ checkoutConfiguration, ageVerificationPopup, ageVerificationMethodImages }) => {
  const cartConfiguration: CartConfiguration = {
    loyalty: mapLoyalty(checkoutConfiguration),
    ageVerificationPopup: {
      description: ageVerificationPopup?.description || "",
      successMessage: ageVerificationPopup?.successMessage || "",
      popupMode: !!ageVerificationPopup?.popupMode,
    },
    ageVerificationMethodImages: mapAgeVerificationMethodImages(ageVerificationMethodImages),
  };

  return (
    <Container>
      <CartApp data={cartConfiguration} />
    </Container>
  );
};
